// no itx for this file

// Limitations:
// no stable nested swich statements
// While/Wend: no stack tracking; nested While/Wend may produce wrong braces
//

import { runTests } from "./transtpilerTests";

// so far unhandled string functions:
//
// Function Name	Description
// InStr	Returns the first occurrence of the specified substring. Search happens from left to right.
// InstrRev	Returns the first occurrence of the specified substring. Search happens from Right to Left.
// Lcase	Returns the lower case of the specified string.
// Ucase	Returns the Upper case of the specified string.
// Left	Returns a specific number of characters from the left side of the string.
// Right	Returns a specific number of characters from the Right side of the string.
// Mid	Returns a specific number of characters from a string based on the specified parameters.
// Ltrim	Returns a string after removing the spaces on the left side of the specified string.
// Rtrim	Returns a string after removing the spaces on the right side of the specified string.
// Trim	Returns a string value after removing both leading and trailing blank spaces.
// Len	Returns the length of the given string.
// Replace	Returns a string after replacing a string with another string.
// Space	Fills a string with the specified number of spaces.
// StrComp	Returns an integer value after comparing the two specified strings.
// String	Returns a String with a specified character the specified number of times.
// StrReverse	Returns a String after reversing the sequece of the characters of the given string.

///////////////////////////////////////////////////////////////////////////////////////////////////////////
// so far unhandled: Arrays
//
// Array Declaration
// Arrays are declared the same way a variable has been declared except that the declaration of an array variable uses parenthesis. In the following example, the size of the array is mentioned in the brackets.

// 'Method 1 : Using Dim
// Dim arr1() 'Without Size

// 'Method 2 : Mentioning the Size
// Dim arr2(5) 'Declared with size of 5

// 'Method 3 : using 'Array' Parameter
// Dim arr3
// arr3 = Array("apple","Orange","Grapes")

function stripStartingWith(line: string, pattern: string): string {
  const p = line.indexOf(pattern);
  if (p > 0) {
    return line.substring(0, p);
  } else {
    return line;
  }
}

function replaceAllCaseInseitive(line: string, oldPattern: string, newPattern: string): string | undefined {
  var regEx = new RegExp("\\b" + oldPattern + "\\b", "gi");

  const res = line.replace(regEx, newPattern);
  if (res != line) {
    return res;
  }
  return undefined;
}

function findBetween(line: string, p1: string, p2: string): string {
  const l = line.toLowerCase();
  const i1 = l.indexOf(p1);
  const i2 = l.indexOf(p2);

  const res = l.substring(i1 + p1.length, i2).trim();

  return res;
}

//// needed standad functions
export const vbscriptStandartFuncs: any = {
  Int: function (input: string): number {
    return parseInt(input);
  },

  CInt: function (input: string): number {
    return parseInt(input);
  },

  // (int)
};

export function transpile(source: string): string {
  const lines = source.split("\n");

  const res: any = [];

  //////////////////////////////////////
  //
  // transpiler state varibales
  //
  let selectCaseIsOpen = false;
  let doIsOpen = false;

  ///////////////////////////////////////

  function transpileOneLine(line1: string): string {
    var line = line1;

    let res: string | undefined;

    line = stripStartingWith(line, "rem");
    line = stripStartingWith(line, "'");

    ////////////////////////////////////////////////////////////////

    line = line.replace("&", "+");

    line = replaceAllCaseInseitive(line, "And", "&&") || line;
    line = replaceAllCaseInseitive(line, "Or", "||") || line;

    line = line.replace("^", "**");
    line = line.replace("<>", "!=");

    line = line.replace("(int)", "CInt");
    line = line.replace("(Int)", "CInt");

    line = replaceAllCaseInseitive(line, "cint", "CInt") || line;
    line = replaceAllCaseInseitive(line, "int", "Int") || line;

    line = replaceAllCaseInseitive(line, "mod", "%") || line;

    ///////////////////////////////////////////////////////////////

    res = replaceAllCaseInseitive(line, "dim", "// let ");
    if (res) {
      return res;
    }

    res = replaceAllCaseInseitive(line, "end if", "}");
    if (res) {
      return res;
    }

    line = replaceAllCaseInseitive(line, "then", ") {") || line;
    line = replaceAllCaseInseitive(line, "else", "} {") || line;
    res = replaceAllCaseInseitive(line, "if", "if (");
    if (res) {
      return res;
    }

    res = replaceAllCaseInseitive(line, "do while", "while (");
    if (res) {
      return res + ") {";
    }
    res = replaceAllCaseInseitive(line, "loop", "}");
    if (res) {
      return res;
    }

    // While … Wend (VBScript). Must run after "do while" / "loop" so "Loop While …" is not mistaken for this.
    {
      const whileWend = line.match(/^\s*while\b\s*(.+)$/i);
      if (whileWend) {
        return `while (${whileWend[1].trim()}) {`;
      }
    }

    res = replaceAllCaseInseitive(line, "wend", "}");
    if (res) {
      return res;
    }

    // select case <var>
    //
    //
    res = replaceAllCaseInseitive(line, "select case", "switch (");
    if (res) {
      selectCaseIsOpen = false;
      return res + ") {";
    }

    res = replaceAllCaseInseitive(line, "case", "case");
    if (res) {
      if (selectCaseIsOpen) {
        res = "break;\n" + res;
      }
      selectCaseIsOpen = true;
      return res + ":";
    }

    res = replaceAllCaseInseitive(line, "end select", "}");
    if (res) {
      selectCaseIsOpen = false;
      return res;
    }

    /////////////////////////////////////////////////////////////////////////////
    // do..while loops	The do..While statements will be executed as long as condition is True.(i.e.,) The Loop should be repeated till the condition is False.
    // do..until loops	The do..Until statements will be executed as long as condition is False.(i.e.,) The Loop should be repeated

    res = replaceAllCaseInseitive(line, "do", "do {");
    if (res) {
      doIsOpen = true;
      return res + ") {";
    }

    if (doIsOpen) {
      res = replaceAllCaseInseitive(line, "while", "} while (");
      if (res) {
        doIsOpen = false;
        return res + ")";
      }

      res = replaceAllCaseInseitive(line, "until", "} while (!(");
      if (res) {
        doIsOpen = false;
        return res + "))";
      }
    }

    /////////////////////////////////////////////////////////////////////////////

    res = replaceAllCaseInseitive(line, "for each", "for (let ");
    if (res) {
      res = replaceAllCaseInseitive(res, " in ", " of ") || res;

      return res + ") {";
    }

    res = replaceAllCaseInseitive(line, "for ", "for (let ");
    if (res) {
      const varName = findBetween(line, "for", "=");

      res = replaceAllCaseInseitive(res, " to ", `; ${varName} <= `);
      res += `; ${varName}++ ) {`;

      return res || "Error: " + line;
    }

    res = replaceAllCaseInseitive(line, "next", "}");
    if (res) {
      return res;
    }

    /////////////////////////////////////////////////////////////////////////////

    res = replaceAllCaseInseitive(line, "exit for", "break;");
    if (res) {
      return res;
    }

    res = replaceAllCaseInseitive(line, "exit do", "break;");
    if (res) {
      return res;
    }

    /////////////////////////////////////////////////////////////////////////////

    // not supported with this super simple approch
    // for loop	Executes a sequence of statements multiple times and abbreviates the code that manages the loop variable.
    // for ..each loop	It is executed if there is at least one element in group and reiterated for each element in a group.

    return line;
  }

  for (var i = 0; i < lines.length; i++) {
    var line = lines[i];
    res.push(transpileOneLine(line));
  }

  return res.join("\n");
}

export default function transpileVbScriptToJavaScript(vbscriptSource: string): string {
  try {
    // runTests();

    var javascriptCode = transpile(vbscriptSource);

    return javascriptCode;
  } catch (ex: any) {
    console.error(`faild to transpile vbscript source: ${ex.message} \n ${vbscriptSource}`);
    return "";
  }
}
